import GroupIcon from "@mui/icons-material/Group";
import VideocamIcon from "@mui/icons-material/Videocam";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import {
    AccountBox,
    Create,
    Description,
    FormatListBulleted,
    LiveHelp,
    MenuBook,
    PostAdd,
    Quiz,
} from "@mui/icons-material";

/**
 * Teachers panel navigation.
 *
 * Route list only - no colors and no active-state logic. SideNav derives the
 * active row from NavLink, and the accent comes from the .admin token scope.
 */
export const ADMIN_NAV = [
    { to: "/admin/groups", label: "گروه‌ها", icon: GroupIcon },
    { to: "/admin/videos", label: "درس‌ها و ویدیوها", icon: VideocamIcon },
    {
        label: "تکلیف",
        icon: Description,
        children: [
            {
                to: "/admin/homework/list",
                label: "لیست تکالیف",
                icon: FormatListBulleted,
            },
            {
                to: "/admin/homework/answers",
                label: "پنل تصحیح",
                icon: Create,
            },
        ],
    },
    { to: "/admin/questions", label: "بانک سوال", icon: LiveHelp },
    { to: "/admin/question-cat", label: "ساخت آزمون", icon: PostAdd },
    { to: "/admin/exams", label: "آزمون", icon: Quiz },
    { to: "/admin/management/student", label: "دانش آموزان", icon: AccountBox },
    { to: "/admin/books", label: "جزوات", icon: MenuBook },
];

export const adminFooterNav = (onLogout) => [
    {
        label: "خروج",
        icon: LogoutRoundedIcon,
        onClick: onLogout,
        tone: "danger",
    },
];
